import React from "react";
import { Link } from "react-router-dom";
import "../css/terms.scss";

function Terms() {
  return (
    <main className="terms policy-page">
      <div className="policy-container">
        <p className="policy-updated">Last updated: 7 September 2026</p>
        <h1 className="policy-title">Terms of Use</h1>
        <div className="policy-content">
          <p>These terms apply when you browse uightparcel.shop. By using the site, you agree to these terms. If you do not agree, please stop using it.</p>

          <h2>Catalogue preview</h2>
          <p>The site currently presents a preview catalogue. Adding an item to a selection or reviewing that selection does not place an order, reserve stock, create a sales contract or take payment. Product availability, price, delivery, taxes and final terms must be confirmed separately before any purchase.</p>

          <h2>Accuracy and availability</h2>
          <p>We aim to keep content clear and accurate, but preview information may change. Product images are AI-generated visual representations and are not photographs of production stock. Do not rely on colour, proportion, construction or finish shown in an image as an exact product representation.</p>

          <h2>Permitted use</h2>
          <p>You may use the site for personal, lawful browsing. You must not interfere with the site, attempt unauthorised access, introduce malicious code, scrape it in a way that disrupts service, impersonate another person, or use site content to mislead others.</p>

          <h2>Intellectual property</h2>
          <p>The Uightparcel name, original text, layout and code-generated artwork on this version of the site are protected to the extent provided by applicable law. You may not reproduce them commercially without permission. See our <Link to="/intellectual-property">IP &amp; Takedown Policy</Link> if you believe any material affects your rights.</p>

          <h2>Third-party services and links</h2>
          <p>Your device, browser, email provider and hosting services may be governed by separate terms. A link to another service does not mean we control or endorse it.</p>

          <h2>Liability</h2>
          <p>Nothing in these terms excludes liability that cannot lawfully be excluded. To the extent permitted by law, the site is provided on an “as available” basis and we are not responsible for indirect loss caused by use of, or inability to use, this preview site.</p>

          <h2>Privacy</h2>
          <p>Our <Link to="/privacy">Privacy Policy</Link> and <Link to="/cookies">Cookie Notice</Link> explain how information and browser storage are handled.</p>

          <h2>Changes and contact</h2>
          <p>We may update these terms as the store develops. For questions, email <a href="mailto:track@uightparcel.shop?subject=Terms%20question">track@uightparcel.shop</a>.</p>
        </div>
      </div>
    </main>
  );
}

export default Terms;
